import React from 'react'
import createSvgIcon from 'client/icons/createSvgIcon'

export default createSvgIcon(
  <path d="M14.4 7H21c.6 0 1 .4 1 1s-.4 1-1 1h-6.6l2.3 2.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-4-4c-.05-.05-.075-.1-.1-.15-.025-.05-.05-.1-.1-.15-.1-.3-.1-.5 0-.8 0-.1.1-.2.2-.3l4-4c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L14.4 7zm-1.6 8.45c.025.05.05.1.1.15.1.3.1.5 0 .8 0 .1-.1.2-.2.3l-4 4c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1 0-1.4L9.6 17H3c-.6 0-1-.4-1-1s.4-1 1-1h6.6l-2.3-2.3c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l4 4c.05.05.075.1.1.15z" />,
  'CurrencyExchange'
)
